// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2is_k","consentsList":"PatientConsents_consentsList__3j5gN","consentsListEmpty":"PatientConsents_consentsListEmpty__28NOf"};